import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "w-full flex justify-between"
};
const _hoisted_2 = {
  class: "w-full max-w-sm flex gap-2"
};
const _hoisted_3 = {
  class: "flex flex-col gap-2"
};
const _hoisted_4 = {
  class: "flex items-center justify-end gap-2 flex-wrap"
};
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_6 = {
  class: "text-xs"
};
const _hoisted_7 = {
  class: "w-full max-w-sm flex gap-2"
};
const _hoisted_8 = {
  key: 0,
  class: "h-full flex flex-col text-white"
};
const _hoisted_9 = {
  key: 0,
  class: "h-8 w-8 loading-spinner-main mx-auto shrink-0"
};
const _hoisted_10 = {
  key: 1,
  class: "w-full flex flex-col items-center gap-2"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "w-[30%]"
};
const _hoisted_14 = {
  class: "text-2xs text-main-50"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "w-[30%]"
};
const _hoisted_17 = {
  class: "text-2xs text-main-50"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 1,
  class: "h-full flex flex-col text-white"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputField = _resolveComponent("InputField");
  const _component_Button = _resolveComponent("Button");
  const _component_FiltersBuilder = _resolveComponent("FiltersBuilder");
  const _component_FloatingElement = _resolveComponent("FloatingElement");
  const _component_Collapsible = _resolveComponent("Collapsible");
  const _component_CustomTable = _resolveComponent("CustomTable");
  const _component_UserResourcesManager = _resolveComponent("UserResourcesManager");
  const _component_DefaultView = _resolveComponent("DefaultView");
  return _openBlock(), _createBlock(_component_DefaultView, _normalizeProps(_guardReactiveProps(_ctx.view[_ctx.view.current])), _createSlots({
    default: _withCtx(() => [_ctx.view.current === 'notifications' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_ctx.loading.notifications && !_ctx.notificationsList?.total ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : !_ctx.notificationsList?.total ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[9] || (_cache[9] = [_createElementVNode("div", {
      class: "w-[140px] flex items-center justify-center aspect-square rounded-full bg-second-50 shrink-0 animate-fade"
    }, [_createElementVNode("i", {
      class: "icon-bell text-7xl text-second-75"
    })], -1), _createElementVNode("p", {
      class: "font-medium mt-4 text-center"
    }, "Todavía no has actualizado ninguna notificación...", -1), _createElementVNode("p", {
      class: "text-main-10 font-light text-center"
    }, "Haz click en actualizar notificaciones o en configuración para seleccionar los certificados que deseas.", -1)]))) : (_openBlock(), _createBlock(_component_CustomTable, {
      key: 2,
      class: "text-xs text-main-100 [&_td]:py-2 [&_td]:px-3 text-xs [&_th]:font-normal"
    }, {
      header: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationProperties, notificationProperty => {
        return _openBlock(), _createElementBlock("th", {
          key: notificationProperty
        }, [_createElementVNode("div", {
          class: "flex items-center gap-2 cursor-pointer hover:bg-main-100/10 py-0.5 px-1 rounded transition-colors",
          onClick: $event => $options.changeSort(notificationProperty.key)
        }, [_createTextVNode(_toDisplayString(notificationProperty.label) + " ", 1), _createElementVNode("i", {
          class: _normalizeClass(["icon-chevron-down text-3xs transition-transform", {
            'hidden': _ctx.notificationsQuery.sortby !== notificationProperty.key,
            '-rotate-180': _ctx.notificationsQuery.sortdir === 'asc'
          }])
        }, null, 2)], 8, _hoisted_11)]);
      }), 128)), _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1))]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationsList?.items, notification => {
        return _openBlock(), _createElementBlock("tr", {
          key: notification,
          class: _normalizeClass(["cursor-pointer transition-opacity", {
            'opacity-40': _ctx.loading.notifications
          }]),
          onClick: $event => notification.open = !notification.open
        }, [_createElementVNode("td", null, _toDisplayString(notification.titular), 1), _createElementVNode("td", _hoisted_13, [_createElementVNode("p", null, _toDisplayString(notification.organoEmisor), 1), _createVNode(_component_Collapsible, {
          collapsed: !notification.open,
          duration: "200"
        }, {
          default: _withCtx(() => [_createElementVNode("p", _hoisted_14, [_createTextVNode(_toDisplayString(notification.codProcedimiento) + " ", 1), _createElementVNode("span", {
            class: "icon-copy text-sm ml-1",
            onClick: _withModifiers($event => _ctx.$clipboard(notification.codProcedimiento), ["stop"])
          }, null, 8, _hoisted_15)])]),
          _: 2
        }, 1032, ["collapsed"])]), _createElementVNode("td", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(notification.concepto), 1), _createVNode(_component_Collapsible, {
          collapsed: !notification.open,
          duration: "200"
        }, {
          default: _withCtx(() => [_createElementVNode("p", _hoisted_17, [_createTextVNode(" ID: " + _toDisplayString(notification._id) + " ", 1), _createElementVNode("span", {
            class: "icon-copy text-sm ml-1",
            onClick: _withModifiers($event => _ctx.$clipboard(notification._id), ["stop"])
          }, null, 8, _hoisted_18)])]),
          _: 2
        }, 1032, ["collapsed"])]), _createElementVNode("td", null, _toDisplayString(this.$formatDate({
          date: notification.disposicion,
          format: 'dd/mm/yyyy'
        })), 1), _createElementVNode("td", null, _toDisplayString(this.$formatDate({
          date: notification.caducidad,
          format: 'dd/mm/yyyy'
        })), 1), _createElementVNode("td", null, [_createVNode(_component_Button, {
          size: "xs",
          variant: "tinted",
          icon: "icon-next",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        })])], 10, _hoisted_12);
      }), 128))]),
      _: 1
    }))])) : _ctx.view.current === 'configuration' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_UserResourcesManager, {
      modelValue: _ctx.selectedCertificates,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.selectedCertificates = $event),
      externalSearchKeyword: _ctx.certificateSearchKeyword,
      searchInputField: false,
      scrollLimit: false,
      multiple: true,
      persistentSelection: false,
      type: "certificates",
      shared: false,
      selectable: false
    }, null, 8, ["modelValue", "externalSearchKeyword"])])) : _createCommentVNode("", true)]),
    _: 2
  }, [_ctx.view.current === 'notifications' ? {
    name: "subheader",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_InputField, {
      variant: "outlined_light",
      size: "sm",
      class: "w-full",
      placeholder: "Buscar notificación",
      icon: "icon-search",
      modelValue: _ctx.notificationSearchKeyword,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.notificationSearchKeyword = $event)
    }, null, 8, ["modelValue"]), _createVNode(_component_Button, {
      variant: "tinted",
      size: "sm",
      text: "Filtrar",
      icon: "icon-filter",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.showNotificationFilters = !_ctx.showNotificationFilters),
      onFocus: _cache[2] || (_cache[2] = $event => _ctx.$handleFocusGroup(() => _ctx.showNotificationFilters = false)),
      "focus-group": "notifications-filters"
    }, {
      default: _withCtx(() => [_ctx.showNotificationFilters ? (_openBlock(), _createBlock(_component_FloatingElement, {
        key: 0,
        position: {
          top: 4,
          left: 0,
          translateY: true
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_FiltersBuilder, {
          config: _ctx.filters,
          "focus-group": "notifications-filters"
        }, {
          default: _withCtx(() => [_createVNode(_component_Button, {
            variant: "secondary",
            size: "xs",
            text: "Aplicar",
            onClick: _withModifiers($options.applyFilters, ["stop"]),
            class: "self-end"
          }, null, 8, ["onClick"])]),
          _: 1
        }, 8, ["config"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$options.selectedCertificatesText ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("i", {
      class: "icon-certificate text-lg"
    }, null, -1)), _createElementVNode("p", _hoisted_6, _toDisplayString($options.selectedCertificatesText), 1)])) : _createCommentVNode("", true), _createVNode(_component_Button, {
      variant: "tinted",
      size: "sm",
      text: "Configuración",
      icon: "icon-gear",
      onClick: _cache[3] || (_cache[3] = $event => _ctx.view.current = 'configuration')
    }), _createVNode(_component_Button, {
      variant: "primary",
      size: "sm",
      text: "Actualizar notificaciones",
      onClick: _cache[4] || (_cache[4] = $event => $options.GetNotificationsFromDehu()),
      loading: _ctx.loading.scraping
    }, null, 8, ["loading"])])])])]),
    key: "0"
  } : _ctx.view.current === 'configuration' ? {
    name: "header",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_InputField, {
      variant: "outlined_light",
      size: "sm",
      class: "w-full",
      placeholder: "Buscar certificado",
      icon: "icon-search",
      modelValue: _ctx.certificateSearchKeyword,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.certificateSearchKeyword = $event)
    }, null, 8, ["modelValue"])])]),
    key: "1"
  } : undefined]), 1040);
}